import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { BsCloudArrowUp } from "react-icons/bs";
import { FaArrowLeft, FaRegSave, FaTable } from "react-icons/fa";
import { MdDelete, MdMessage, MdUpload,MdArrowBack } from "react-icons/md";
import { TiTick } from "react-icons/ti";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_ROUTES, REACT_APP_API_URL } from "../../config/api-config";
import "./AddStudents.css";
import AddCamera from "./AddCamera";
import { useLocation, useHistory, useParams } from "react-router-dom";
import EditStaffDetails from "components/edit-student/indexstaff";
import EditStudentDetails from "components/edit-student/index";
import { useMemo } from "react";
import "./StudentRegistration.css";
import ImageCropper from "./AddCamera";
import "./LogoLoader.css";
import { Password } from "@mui/icons-material";
import "./LogoLoaders.css";
import AutoFaceIdCamera from "./AutoFaceIdCamera";

const StudentRegistration = () => {
  const location = useLocation();
  const students_id = location.state || {};
  console.log('ooooooooooooooooooooooooooooooooool', students_id)

  const [student_id, setStudentId] = useState(students_id.student_id);
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [membership_start_date, setMembershipStartDate] = useState("");
  const [membership_end_date, setMembershipEndDate] = useState("");
  const [selectType, setSelectType] = useState('');
  const [area_id, setAreaId] = useState("");
  const [shift_id, setShiftId] = useState("");
  const [image, setImage] = useState("");
  const [imageName, setImageName] = useState("");
  const [saimage, setSaImage] = useState("");
  const [saimageName, setSaImageName] = useState("");
  const [email, setEmailId] = useState("");
  const [mobile_no, setMobileNumber] = useState("");
  
  // New States for Buying Behaviour, Pricing, and Currency
  const [buyingBehaviour, setBuyingBehaviour] = useState("");
  const [pricing, setPricing] = useState("");
  const [currency, setCurrency] = useState("");

  const [uploadImage, setUploadImage] = useState(false);
  const [capturedImages, setCapturedImages] = useState([]);
  const token = localStorage.getItem("accessToken");
  const [section, setSection] = useState("");
  const [images, setImages] = useState([]);
  const [multeImage, setMulteImage] = useState([]);
  
  const [loading, setLoading] = useState(false);

  const videoRef = useRef(null);
  const history = useHistory();

  const [allImages, setAllImages] = useState([]);

  const { student_id: editId } = useParams();
  const isEdit = Boolean(editId);

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const sessionTypes = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];

  // New Options Arrays
  const buyingBehaviours = [
    { value: "Impulse", label: "Impulse Buyer" },
    { value: "Discount", label: "Discount Seeker" },
    { value: "Loyal", label: "Loyal Customer" },
    { value: "Needs-Based", label: "Needs-Based Shopper" },
    { value: "Wandering", label: "Wandering Customer" },
  ];

  const pricingTiers = [
    { value: "0-10k", label: "0 - 10k" },
    { value: "10-20k", label: "10 - 20k" },
    { value: "20-30k", label: "20 - 30k" },
    { value: "30-40k", label: "30 - 40k" },
    { value: "40-50k+", label: "40 - 50k+" },
  ];

  const currencies = [
    { value: "INR", label: "INR (₹)" },
    { value: "USD", label: "USD ($)" },
    { value: "EUR", label: "EUR (€)" },
    { value: "GBP", label: "GBP (£)" },
  ];

  const handleMultipleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setAllImages((prev) => [...prev, ...files]);
    setMulteImage((prev) => [...prev, ...files]);
  };

  const handleImageCapture = (files) => {
    setAllImages((prev) => [...prev, files]);
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
    });

  const handleSubmit = () => {
    setLoading(true);

    Promise.all(
      allImages.map((img) => {
        if (img instanceof File) {
          return readFileAsBase64(img);
        }
        return img;
      })
    )
      .then((images) => {
        if (images.length === 0) {
          toast.warn("Please upload at least one image");
          setLoading(false);
          return Promise.reject("No images uploaded");
        }
        if (student_id.length === 0) {
          toast.warn("Student ID required");
          setLoading(false);
          return Promise.reject("Student ID required");
        }

        const img1 = images.map((img) => img.split(",")[1]);

        if (!student_id) {
          toast.warn("Student ID is required");
          return;
        }
        if (!first_name) {
          toast.warn("First name is required");
          return;
        }
        if (!last_name) {
          toast.warn("Last name is required");
          return;
        }
        if (!email) {
          toast.warn("Email is required");
          return;
        }
        if (!mobile_no) {
          toast.warn("Contact number is required");
          return;
        }
        if (!selectType) {
          toast.warn("Gender is required");
          return;
        }

        if (!buyingBehaviour) {
          toast.warn("Buying behaviour is required");
          return;
        }
        if (!pricing) {
          toast.warn("Pricing is required");
          return;
        }
        if (!currency) {
          toast.warn("Currency is required");
          return;
        }

        // Adding a "/" guarantees the URL is formatted correctly
        return fetch(`${REACT_APP_API_URL}/${API_ROUTES.add_student}`.replace(/([^:]\/)\/+/g, "$1"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            student_id,
            first_name,
            last_name,
            email,
            mobile_no,
            selectType,
            membership_start_date,
            membership_end_date,
            buying_behaviour: buyingBehaviour,
            pricing,
            currency,
            section,
            images,
            password,
          }),
        }).then(async (res) => {
          const data = await res.json().catch(() => null);

          if (res?.status === 201) {
            toast.success("Registered Successfully");
            // Reset all fields
            setStudentId("");
            setFirstName("");
            setLastName("");
            setMembershipStartDate("");
            setMembershipEndDate("");
            setSelectType("");
            setBuyingBehaviour("");
            setPricing("");
            setCurrency("");
            setSection("");
            setPassword("");
            setAreaId("");
            setShiftId("");
            setImage("");
            setImageName("");
            setSaImage("");
            setSaImageName("");
            setCapturedImages([]);
            setEmailId("");
            setMobileNumber("");
            setMulteImage([]);
            setAllImages([]);

            history.push("/admin/FaceDetails");
          } else {
            toast.error(data && data.detail)
          }
        });
      })
      .catch((error) => {
        console.log("errora", error)
        toast.error(error)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const removeImage = (indexToRemove) => {
    setAllImages((prev) => prev.filter((_, i) => i !== indexToRemove));
    setMulteImage((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setImage(file);
    setImageName(file.name);
  };

 return (
    <>
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
            <div className="container">
        <div className="form-section">
          {/* ✅ BACK BUTTON */}
          <button 
            onClick={() => history.push("/admin/FaceDetails")}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              backgroundColor: 'transparent',
              border: 'none',
              color: '#6b7280',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: '600',
              marginBottom: '20px',
              padding: 0
            }}
          >
            <MdArrowBack size={20} />
            Back to Menu
          </button>

          <h2>Customer Form</h2>

          <div className="form-group">
            <label className="lebcs">ID</label>
            <input
              className="Asss"
              type="text"
              value={student_id}
              onChange={(e) => setStudentId(e.target.value)}
              placeholder="Enter ID"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">First Name</label>
              <input
                className="Asss"
                type="text"
                placeholder="First Name"
                value={first_name}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="lebcs">Last Name</label>
              <input
                className="Asss"
                type="text"
                placeholder="Last Name"
                value={last_name}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Email</label>
              <input
                className="Asss"
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmailId(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="lebcs">Gender</label>
              <select
                className="Asss"
                value={selectType}
                onChange={(e) => setSelectType(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Gender
                </option>
                {sessionTypes.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Contact Details</label>
              <input
                className="Asss"
                type="tel"
                placeholder="Contact Number"
                value={mobile_no}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">

            </div>


          </div>

          {/* New Fields for Buying Behaviour, Pricing, and Currency */}
          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Buying Behaviour</label>
              <select
                className="Asss"
                value={buyingBehaviour}
                onChange={(e) => setBuyingBehaviour(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Behaviour
                </option>
                {buyingBehaviours.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="lebcs">Pricing</label>
              <select
                className="Asss"
                value={pricing}
                onChange={(e) => setPricing(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Pricing Range
                </option>
                {pricingTiers.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Currency</label>
              <select
                className="Asss"
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Currency
                </option>
                {currencies.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

        </div>

        {/* --- CAMERA AND GALLERY SECTION --- */}
        <div className="camera-section">
          <h2>Live Camera</h2>
          
          <AutoFaceIdCamera onImageCapture={handleImageCapture} />
          
          <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "15px" }}>
            
            {/* Upload Button */}
            <label style={{ 
                color: '#fff', 
                backgroundColor: '#00bcd4',
                padding: '10px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontWeight: 'bold',
                boxShadow: '0 4px 10px rgba(0, 188, 212, 0.3)',
                marginBottom: '15px'
              }} 
              htmlFor="student_images"
            >
              Upload Image(s)
              <MdUpload size={20} />
              <input
                className="Asss"
                id="student_images"
                accept=".png, .jpeg, .jpg"
                style={{ display: "none" }}
                type="file"
                multiple
                onChange={handleMultipleImageChange}
              />
            </label>

            {/* Visual Gallery with Delete Buttons Moved Here */}
            {allImages.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center", width: "100%" }}>
                {allImages.map((img, index) => {
                  const isFile = img instanceof File || img instanceof Blob;
                  const imgSrc = isFile ? URL.createObjectURL(img) : img;

                  return (
                    <div key={index} style={{ position: "relative", width: "70px", height: "70px" }}>
                      <img 
                        src={imgSrc} 
                        alt={`captured-face-${index}`} 
                        style={{ 
                          width: "100%", 
                          height: "100%", 
                          objectFit: "cover", 
                          borderRadius: "8px", 
                          border: "2px solid #00bcd4" 
                        }} 
                      />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute",
                          top: "-6px",
                          right: "-6px",
                          background: "#ff4444",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          width: "22px",
                          height: "22px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          boxShadow: "0 2px 5px rgba(0,0,0,0.4)"
                        }}
                      >
                        <MdDelete size={14} />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
            
          </div>
        </div>
      </div>

      <div style={{ width: '100%', paddingLeft: '172px', paddingRight: '172px', marginTop: '20px', marginBottom: '40px' }}>
        <button className="upload-btn" onClick={handleSubmit} style={{ width: '100%' }}>
          Register
        </button>
      </div>
    </>
  );
};

export default StudentRegistration;
